module.exports = __webpack_public_path__ + "static/media/raju-reddy.c1587ad5.jpeg";